"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _projectInfo = require("@/api/projectInfo");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _default = exports.default = {
  name: 'energySaved',
  data: function data() {
    return {
      params: {
        endDate: (0, _dayjs.default)().endOf('month').format('YYYY-MM-DD') + " 23:59:59",
        projectId: this.$store.state.project.projectInfo.id,
        id: this.$store.state.project.projectInfo.id,
        startDate: (0, _dayjs.default)().startOf('month').format('YYYY-MM-DD') + " 00:00:00",
        type: 0
      },
      dataTimes: [],
      chartData: {
        dayData: 0,
        monthData: 0,
        yearData: 0,
        carbonEmission: 0,
        energyStandardTime: '',
        dayPct: '',
        monthPct: '',
        yearPct: ''
      },
      energyCount: {
        dayData: [],
        monthData: [],
        yearData: []
      },
      energyInor: {
        dayData: [],
        monthData: [],
        yearData: []
      },
      energyData: {
        consumption: '',
        //	耗电量	number(double)	
        energySaved: '',
        //		节能量	number(double)	
        time: '' //	
      },
      energyInfor: [],
      consumption: [],
      energySaved: [],
      time: [],
      list: [],
      list1: [],
      count: [],
      count1: [],
      value: '',
      type: 0,
      co2_unit: 'kg',
      startDate: '',
      endDate: '',
      zoom: '',
      zoomrAtio: ''
    };
  },
  props: {},
  computed: {},
  created: function created() {
    this.energySavedHistoryData();
    this.energyStatistics();
    this.columnEchart();
  },
  methods: {
    energyStatistics: function energyStatistics() {
      var ts = this;
      var par = {
        projectId: this.$store.state.project.projectInfo.id
      };
      (0, _projectInfo.energySavedHistoryStatistics)(par).then(function (res) {
        ts.chartData = res;
        ts.chartData.carbonEmission = Math.floor(ts.chartData.carbonEmission * 100) / 100;
        ts.chartData.dayData = ts.chartData.dayData * 1;
        ts.chartData.monthData = ts.chartData.monthData * 1;
        ts.chartData.yearData = ts.chartData.yearData * 1;
      });
    },
    checkDate: function checkDate(type) {
      this.type = type;
      if (type === 0) {
        //当前月的开始时间和结束时间
        var startDate = (0, _dayjs.default)().startOf('month').format('YYYY-MM-DD');
        var endDate = (0, _dayjs.default)().endOf('month').format('YYYY-MM-DD');
        this.params.startDate = startDate + " 00:00:00";
        this.params.endDate = endDate + " 23:59:59";
      }
      if (type == 1) {
        //当前月前的六个月为开始时间
        var _startDate = (0, _dayjs.default)().subtract(6, 'month').startOf('month').format('YYYY-MM-DD');
        var _endDate = (0, _dayjs.default)().endOf('month').format('YYYY-MM-DD');
        this.params.startDate = _startDate + " 00:00:00";
        this.params.endDate = _endDate + " 23:59:59";
      }
      if (type == 2) {
        //当前年前的六年为开始时间
        var _startDate2 = (0, _dayjs.default)().subtract(6, 'year').startOf('year').format('YYYY-MM-DD');
        var _endDate2 = (0, _dayjs.default)().endOf('year').format('YYYY-MM-DD');
        this.params.startDate = _startDate2 + " 00:00:00";
        this.params.endDate = _endDate2 + " 23:59:59";
      }
      this.energySavedHistoryData();
    },
    //节能量数据
    energySavedHistoryData: function energySavedHistoryData() {
      var _this = this;
      var ts = this;
      ts.params.type = ts.type;
      this.time = [];
      this.consumption = [];
      this.energySaved = [];
      (0, _projectInfo.energySavedHistoryData)(ts.params).then(function (res) {
        ts.energyInfor = res;

        // 设置默认获取日的统计数据
        for (var i = 0; i < _this.energyInfor.length; i++) {
          _this.time.push(_this.energyInfor[i].time);
          _this.consumption.push(_this.energyInfor[i].consumption);
          _this.energySaved.push(_this.energyInfor[i].energySaved);
        }
        //重新生产统计图
        ts.columnEchart();
      });
    },
    //节能量数据
    columnEchart: function columnEchart() {
      var _this2 = this;
      var ts = this;
      var columnEchart = this.$echarts.init(document.getElementById("columnEchart"));
      var emphasisStyle = {
        itemStyle: {
          shadowBlur: 10,
          shadowColor: 'rgba(0,0,0,0.2)'
        }
      };
      var option = {
        grid: {
          left: "2%",
          right: "3%",
          top: "15%",
          bottom: "5%",
          width: 'auto',
          height: 'auto',
          containLabel: true
        },
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100
        }],
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params) {
            var result = params[0].name + "<br>";
            var allCount = 0;
            params.forEach(function (item) {
              if (!item.value) {
                item.value = 0;
              }
              allCount += item.value * 1;
            });
            params.forEach(function (item) {
              if (ts.$store.getters.language == 'en') {
                item.seriesName = ts.$t('esdata.jnl');
              }
              if (item.value) {
                result += item.marker + " " + item.seriesName + " : " + item.value + "kWh";
              } else {
                result += item.marker + " " + item.seriesName + " : - </br>";
              }
              console.log("item.seriesName{}", result);
            });
            return result;
          }
        },
        // title: {
        //     text: ts.$t('esdata.jnl'), 
        //     left: 'center',
        //     top: '5%',
        //     textStyle: {
        //         color: '#FFFFFF',  // 白色文字
        //         fontSize: 16,
        //         fontWeight: 'bold',
        //     }
        // },
        xAxis: [{
          type: 'category',
          data: ts.time.length > 0 ? ts.time : ['', '', '', '', '', '', '', '', '', '', '', '']
        }],
        yAxis: [{
          type: 'value',
          splitLine: {
            lineStyle: {
              color: this.echartYLine
            }
          }
        }],
        series: [{
          name: ts.$t('esdata.jnl'),
          type: 'bar',
          barWidth: '10%',
          // 修改柱状图宽度为6%
          barMaxWidth: '20%',
          // 最大宽度为50%
          stack: 'one',
          emphasis: ts.energySaved,
          itemStyle: {
            normal: {
              // 设置柱状图的渐变色
              color: new ts.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(42, 130, 228, 1)'
              }, {
                offset: 1,
                color: 'rgba(32, 133, 247, 0)'
              }], false)
            }
          },
          data: ts.energySaved.length > 0 ? ts.energySaved : [0, 0, 0, 0, 0, 0, 0]
        }]
      };
      columnEchart.setOption(option);
      this.$nextTick(function () {
        _this2.$nextTick(function () {
          _this2.zoom = document.body.style.zoom;
          _this2.zoomrAtio = (1 / document.body.style.zoom).toFixed(2);
        });
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;
    setTimeout(function () {
      _this3.columnEchart();
    }, 20);
  }
};